module.exports = __webpack_public_path__ + "img/ico_8.8e421086.png";